/**
 *
 */
(function($){
	var position = $(window).width() < 1200 ? { my: "left top", at: "left top", of: window, collision: 'none', offset: '5 70' } : 'center top';

	$.widget('ui.wrapLink', {
		options: {
			reloadOnClose: false,
			requireConfirmToClose: false,
			position: position,
			width: false,
			title: '',
			sourceAttr: 'href',
			source: false,
			symbol: false,
			events: {
				close: false,
				beforeClose: false,
				save: false
			},
			windowed: false
		},

		_intialInitDialog: function(){
			// Add data-skip-sanitize to bypass DOMPurify stripping iframes
			$('body').append('<div id="wrapLinkBox" data-skip-sanitize="true" style="display:none"></div>');

			var reloadOnClose = this.options.reloadOnClose;
			$('#wrapLinkBox').dialog({
				autoOpen: false,
				draggable: true,
				height: 'auto',
				modal: true,
				resizable: false,
				position: this.options.position,
				dialogClass: 'wrapLinkDialog',
				beforeClose: function(){
					if($(this).data('requireConfirmToClose')){
						if(!confirm('Are you sure you want to close this popup? Any changes made that have not been saved will be lost!')) return false;
					}
					if($.isFunction($(this).data('run_eventbeforeclose'))){
						$(this).data('run_eventbeforeclose')();
					}
				},
				close: function(){
					$('#wrapLinkBox').html('');

					if($.isFunction($(this).data('run_eventsave')) && $(this).data('wraplinkiframe-saved') == true){
						$(this).data('run_eventsave')();
					}
					if($.isFunction($(this).data('run_eventclose'))){
						$(this).data('run_eventclose')();
					}
					if($(this).data('reloadOnClose')){
						$.fullPageLoading(true, 'Loading...');
						window.location.reload(); // Can't use reloadWithParams due to iframe
					}
				},
				open: function() {
					if(window.innerWidth <= $(this).parent().width()) {
						$('#wrapLinkBox').dialog('option', 'position', { my: "left top", at: "left top", of: $('#page-content-wrapper'), collision: 'none', offset: '5 70' });
					}
				},
			});

			$('#wrapLinkBox').data('windowCount', 0);
		},

		_create: function(){
			// If the div doesn't exist, create it
			if($('div#wrapLinkBox').length == 0){
				this._intialInitDialog();
			} else {
				// Ensure skip sanitize attr present for pre-existing containers
				$('div#wrapLinkBox').attr('data-skip-sanitize','true');
			}

			this.element.bind('click', {options: this.options}, this.click);

			// Add the icon
			if(this.options.symbol)
				$('<span class="ui-icon ui-icon-extlink"></span>').appendTo(this.element);
		},

		setOptions: function(option, val){
			this.options[option] = val;
		},

		/**
		 * Click event
		 * @param event
		 */
		click: function(event){
			$(this).qtip('hide');
			$.fullPageLoading(true, 'Loading Page...');
			$('#wrapLinkBox').dialog('option', 'width', event.data.options.width != '' ? event.data.options.width : $(this).data('wraplinkwidth'));
			$('#wrapLinkBox').dialog('option', 'title', event.data.options.title != '' ? event.data.options.title : $(this).data('wraplinktitle'));
			$('#wrapLinkBox').dialog('option', 'position', event.data.options.position);
			$('#wrapLinkBox').data('requireConfirmToClose', event.data.options.requireConfirmToClose);
			$('#wrapLinkBox').data('reloadOnClose', event.data.options.reloadOnClose);
			$('#wrapLinkBox').data('wraplinkiframe-saved', false);

			if($.isFunction(event.data.options.events.close)) $('#wrapLinkBox').data('run_eventclose', event.data.options.events.close);
			if($.isFunction(event.data.options.events.save)) $('#wrapLinkBox').data('run_eventsave', event.data.options.events.save);
			if($.isFunction(event.data.options.events.beforeClose)) $('#wrapLinkBox').data('run_eventbeforeclose', event.data.options.events.beforeClose);

			var srce = (!event.data.options.source) ? $(this).attr(event.data.options.sourceAttr) : event.data.options.source;
			$('#wrapLinkBox').data('wrapsrc', srce);

			// Replace previous HTML string insertion of iframe (blocked by DOMPurify) with DOM element construction
			$('#wrapLinkBox').empty();
			var iframe = document.createElement('iframe');
			iframe.id = 'wrapLinkiFrame';
			iframe.style.width = '100%';
			iframe.style.height = '100%';
			iframe.setAttribute('frameborder','0');
			iframe.setAttribute('scrolling','auto');
			iframe.onload = function(event){ $.wrapLinkIFrameOnLoad(event); };
			iframe.src = srce;
			$('#wrapLinkBox').append(iframe);

			var windowBar = $('<div class="iframe_bottombar"></div>');
			if(event.data.options.windowed == true || typeof $(this).data('wraplinkwindowed') != 'undefined'){
				if(!(typeof $(this).data('wraplinkwindowed') != 'undefined' && $(this).data('wraplinkwindowed') == 'false')){
					var pageLocation = window.location;
					var frameSrce = (/^http/.test(srce)) ? srce : pageLocation.protocol + '//' + pageLocation.hostname + srce;

					$('<button id="iframe_print">Print</button>')
						.button({text: false, icons: {primary: 'ui-icon-print'}})
						.bind('click', function(){
							document.getElementById('wrapLinkiFrame').contentWindow.print();
						})
						.css({
							display: 'inline-block',
							float: 'right'
						})
						.appendTo(windowBar);
				}
			}

			windowBar.appendTo('#wrapLinkBox');


			$('#wrapLinkBox').unbind('wraplinkiframe-loaded');

			if($.isFunction($(this).data('wraplinkcaller')))
				$('#wrapLinkBox').bind('wraplinkiframe-loaded', $(this).data('wraplinkcaller'));

			$('#wrapLinkBox').data('wraplinkiframe-filterremoved','');

			if(typeof $(this).data('wraplinkremovefilter') != 'undefined')
				$('#wrapLinkBox').data('wraplinkiframe-filterremoved', $(this).data('wraplinkremovefilter'));

			$('#wrapLinkBox').data('wraplinkiframe-makeclose','');

			if(typeof $(this).data('wraplinkmakeclose') != 'undefined')
				$('#wrapLinkBox').data('wraplinkiframe-makeclose', $(this).data('wraplinkmakeclose'));


			return false;
		}
	});

	/**
	 * Called by the iFrame when the "onload" param is accessed
	 */
	$.wrapLinkIFrameOnLoad = function(event){
		// Show the dialog
		$('#wrapLinkBox').dialog('open');

		// Figure out the iFrame content height
		var contentHeight = document.getElementById('wrapLinkiFrame').contentWindow.document.body.offsetHeight;

		// Sometimes the height doesn't load immediately, give it a moment and recheck
		if(contentHeight == 0){
			$('#wrapLinkBox').data('windowCount', $('#wrapLinkBox').data('windowCount') + 1);
			if($('#wrapLinkBox').data('windowCount') < 10){
				setTimeout(function(){ $.wrapLinkIFrameOnLoad(event); }, 200);
				return false;
			}else{
				contentHeight = 100;
			}
		}

		contentHeight = contentHeight + 30; // due to browser differences, we add some padding to the height

		$('#wrapLinkBox iframe').css('height', contentHeight + 'px');
		$('#wrapLinkBox').trigger('dialogresize');
		$.fullPageLoading(false);
		$(window).scrollTop(0);

		// Do a quick scan of the iFrame and any "exit" buttons found override their command
		$('#wrapLinkBox iframe').contents().find('img[src="/images/icons/button_exit.gif"],input[src="/images/icons/button_exit.gif"]').each(function(){
			$(this).attr('onclick', '') // Remove their original event
				.bind('click', function(){ // Bind a new click event
					$('#wrapLinkBox').dialog('close');
				})
				.css('cursor', 'pointer');
		});

		// Search for any "save" buttons and add an action to their command
		$('#wrapLinkBox iframe').contents().find('img[src="/images/icons/button_save.gif"],input[src="/images/icons/button_save.gif"]').each(function(){
			$(this).bind('click', function(){ // Bind a new click event
				$('#wrapLinkBox').data('wraplinkiframe-saved', true);
			})
			.css('cursor', 'pointer');
		});

		// Find any help buttons and get rid of them
		$('#wrapLinkBox iframe').contents().find('img[src="/images/icons/button_help_oj.gif"],img[src="/images/icons/button_help.gif"],input[src="/images/icons/button_help_oj.gif"],input[src="/images/icons/button_help.gif"]').hide();

		$('#wrapLinkBox iframe').contents().find('body').removeAttr('bgcolor');

		// Search for any "custom" button filters passed in and remove them
		if(typeof $('#wrapLinkBox').data('wraplinkiframe-filterremoved') != 'undefined'){
			var toRemove = $('#wrapLinkBox iframe').contents().find($('#wrapLinkBox').data('wraplinkiframe-filterremoved')).each(function(){
				$(this).remove();
			});
		}

		if(typeof $('#wrapLinkBox').data('wraplinkiframe-makeclose') != 'undefined'){
			$('#wrapLinkBox iframe').contents().find($('#wrapLinkBox').data('wraplinkiframe-makeclose')).each(function(){
				if($(this).is('a')) {
					$(this).removeAttr('href');
				}

                $(this).attr('onclick', '') // Remove their original event
                    .bind('click', function(){ // Bind a new click event
                        $('#wrapLinkBox').dialog('close');
                    })
                    .css('cursor', 'pointer');
			});
		}


		$('#wrapLinkBox').trigger('wraplinkiframe-loaded', event.type);
	};
})(jQuery);
